<template>
  <div class="knowleagemap-container">
    <div class="container-top">
      <div class="main-title">{{ menu.module_name }}</div>
      <div class="more-btn" @click="handleMore">
        <TrangleButton />
      </div>
    </div>
    <div class="type-list">
      <div class="type-item" :class="{ active: typeId == '' }" @click="searchCourseList('')">
        全部
      </div>
      <div
        class="type-item"
        :class="{ active: item.id == typeId }"
        v-for="item in typeList"
        @click="searchCourseList(item.id)"
      >
        {{ item.name }}
      </div>
    </div>
    <transition name="course-container-fade">
      <div class="course-container" v-if="homeCourseList.length > 0">
        <div class="btn-container">
          <div class="btn-pre" @click="prevPage">
            <CircleButton type="pre" />
          </div>
          <div class="btn-next" @click="nextPage">
            <CircleButton type="next" />
          </div>
        </div>
        <div class="course-list">
          <template v-for="(item, index) in homeCourseList">
            <Transition name="course-item-fade">
              <div class="course-item" v-if="activeIndex == index" @click="goDetail(item)">
                <div class="item-left">
                  <div class="course-info">
                    <div class="course-title">{{ item.course_name }}</div>
                    <div class="split-line"></div>
                    <div class="teacher">
                      <div class="teacher-img">
                        <img
                          :src="item.avatar || require('@/assets/images/common/teacher_icon.png')"
                        />
                        <span>{{ item.lecturer }}</span>
                      </div>
                      <div class="orga" :title="item.organ_name">{{ item.organ_name }}</div>
                    </div>
                    <div v-if="item.introduction" class="course-desc" :title="item.introduction">
                      {{ item.introduction }}
                    </div>
                  </div>
                  <div class="course-img">
                    <img :src="item.course_cover_url" />
                  </div>
                </div>
                <div class="tab-list" v-if="homeCourseList.length > 0">
                  <waveCanvas />
                  <template v-if="homeCourseList.length > 0">
                    <div
                      @click.stop="handleTabLclick(index)"
                      :class="
                        activeIndex == index
                          ? `tab-item active item-${index}`
                          : `tab-item item-${index}`
                      "
                      v-for="(item, index) in homeCourseList"
                    >
                      <!-- 使用圆环倒计时组件 -->
                      <CircleTimer v-if="activeIndex == index" ref="timer" :size="48" />
                      <div class="inner"></div>
                    </div>
                  </template>
                </div>
              </div>
            </Transition>
          </template>
        </div>
      </div>
      <div class="course-container" v-else>
        <Empty type="course" />
      </div>
    </transition>
  </div>
</template>
<script>
import { Empty } from 'zhs-components'
import { handleLogin } from '@/plugins/utils'
import waveCanvas from './waveCanvas.vue'
import CircleTimer from './CircleTimer.vue'
import CircleButton from './CircleButton.vue'
import TrangleButton from './TrangleButton.vue'

export default {
  components: {
    Empty,
    waveCanvas,
    CircleTimer,
    CircleButton,
    TrangleButton
  },
  props: {
    courseType: Number,
    menu: Object,
    userInfo: {
      type: Object,
      default: null
    },
    zhsRole: {
      type: Number || String,
      default: 0
    }
  },
  inject: ['$schoolId'],
  created() {
    this.getAuth()
    this.getTypeList()
  },
  mounted() {
    this.startInterval()
  },
  unmounted() {
    clearInterval(this.courseInterval)
  },
  watch: {
    typeId: {
      handler(val) {
        this.getHomeCourseList()
      },
      immediate: true
    }
  },
  data() {
    return {
      homeCourseList: [],
      courseCategorys: [],
      authType: 0,
      typeList: [],
      hiddenMoreClass: true,
      typeId: '',
      activeIndex: 0,
      courseInterval: null,
      timer: 10000
    }
  },
  methods: {
    handleTabLclick(index) {
      this.startInterval()
      this.activeIndex = index
    },
    goDetail(item) {
      if (!this.userInfo) {
        handleLogin()
      } else {
        window.open(item.course_url)
      }
    },
    startInterval() {
      clearInterval(this.courseInterval)
      this.courseInterval = setInterval(() => {
        if (this.activeIndex == this.homeCourseList.length - 1) {
          this.activeIndex = 0
        } else {
          this.activeIndex++
        }
      }, this.timer)
    },
    handleMore() {
      if (this.$schoolId == 894) {
        window.open('http://t.zhihuishu.com/0LlGVzvv')
      } else {
        window.open(
          `/courseList.html?type=1&name=${this.menu.module_name}&menuId=${this.menu.menu_id}`
        )
      }
    },
    prevPage() {
      this.startInterval()
      if (this.activeIndex > 0) {
        this.activeIndex--
      } else {
        this.activeIndex = this.homeCourseList.length - 1
      }
    },
    nextPage() {
      this.startInterval()
      if (this.activeIndex < this.homeCourseList.length - 1) {
        this.activeIndex++
      } else {
        this.activeIndex = 0
      }
    },
    async getHomeCourseList() {
      const homeCourse = await this.$http.getHomeMooc({
        num: this.menu.num,
        menu_id: this.menu.menu_id,
        classify_id: this.typeId
      })
      console.log(homeCourse, 'ioioipipoipoiopi参数')
      this.homeCourseList = homeCourse
    },
    async getAuth() {
      const res2 = await this.$http.getConfigList()
      this.authType = res2.find(item => item.code == '10401')
        ? res2.find(item => item.code == '10401').auth_type
        : 0
    },
    async getTypeList() {
      const res = await this.$http.getCourseType({
        menu_id: this.menu.menu_id
      })
      this.typeList = res
    },
    searchCourseList(id) {
      this.typeId = id
      this.activeIndex = 0
      this.startInterval()
    }
  }
}
</script>

<style lang="scss" scoped>
.knowleagemap-container {
  height: 740px;
  padding: 50px 80px 0;
  box-sizing: border-box;
  position: relative;
  width: 1440px;
  .container-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .main-title {
      color: #1c212a;
      font-family: 'Alibaba PuHuiTi';
      font-size: 32px;
      font-weight: 700;
      &::before {
        content: '';
        display: inline-block;
        width: 4px;
        height: 24px;
        background-color: #194189;
        margin-right: 8px;
      }
    }
  }
  .type-list {
    display: flex;
    margin-top: 10px;
    .type-item {
      width: 112px;
      height: 40px;
      background-color: #f7f8fa;
      color: #1d2129;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      line-height: 40px;
      margin-right: 28px;
      border-radius: 6px;
      cursor: pointer;
      &:hover {
        color: #194189;
      }
      &.active {
        background-color: #194189;
        color: #fff;
      }
    }
  }
  .course-container-fade-enter-active,
  .course-container-fade-leave-active {
    transition: all 0.5s ease;
  }
  .course-container-fade-enter-from {
    opacity: 0;
  }
  .course-container-fade-enter-to {
    opacity: 1;
  }
  .course-container-fade-leave-from {
    opacity: 1;
  }
  .course-container-fade-leave-to {
    opacity: 0;
  }
  .course-container {
    height: 470px;
    margin-top: 70px;
    display: flex;
    .btn-container {
      width: 160px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .btn-pre {
        cursor: pointer;
      }
      .btn-next {
        cursor: pointer;
        margin-top: 74px;
      }
    }
    .course-list {
      width: 1120px;
      height: 100%;
      position: relative;
      .course-item-fade-enter-active,
      .course-item-fade-leave-active {
        transition: all 0.5s ease;
      }
      .course-item-fade-enter-from {
        opacity: 0;
        transform: translateX(1000px);
      }
      .course-item-fade-enter-to {
        opacity: 1;
        transform: translateX(0);
      }
      .course-item-fade-leave-from {
        opacity: 1;
      }
      .course-item-fade-leave-to {
        opacity: 0;
      }
      .course-item {
        background-color: #194189;
        border-radius: 20px;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        z-index: 1;
        .item-left {
          flex: 1;
          display: flex;
          padding: 40px 48px 0;
          .course-info {
            width: 238px;
            margin-right: 40px;
            .course-title {
              color: #fff;
              font-family: 'PingFang SC';
              font-size: 24px;
              font-weight: 500;
            }
            .split-line {
              background-color: #fff;
              height: 1px;
              width: 100%;
              margin: 24px 0 28px;
            }
            .teacher {
              display: flex;
              justify-content: space-between;
              align-items: center;
              .teacher-img {
                display: flex;
                align-items: center;
                img {
                  width: 35px;
                  height: 35px;
                  border: 1px solid #fff;
                  border-radius: 50%;
                  margin-right: 6px;
                }
                span {
                  color: #fff;
                }
              }
              .orga {
                color: rgba(255, 255, 255, 0.7);
                width: 100px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: right;
              }
            }
            .course-desc {
              color: rgba(255, 255, 255, 0.7);
              margin-top: 25px;
              // 显示5行
              display: -webkit-box;
              -webkit-line-clamp: 5;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }
          .course-img {
            height: 370px;
            flex: 1;
            transform: translateY(-92px);
            z-index: 10;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 20px;
            }
          }
        }
        .tab-list {
          height: 56px;
          width: 100%;
          display: flex;
          // border-top: 1px solid #FFFFFF80;
          position: relative;
          .wave-canvas {
            position: absolute;
            bottom: 0px;
            left: 0;
            width: 100%;
            height: 200px;
            z-index: 2;
          }
          .tab-item {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            position: absolute;
            bottom: 40px;
            z-index: 20;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            .inner {
              width: 16px;
              height: 16px;
              border-radius: 50%;
              background-color: #ffffff80;
            }
            &.active {
              .inner {
                background-color: #ffffff;
              }
            }
            &.item-0 {
              left: 121px;
              &::before {
                content: '';
                height: 1px;
                width: 129px;
                background-color: #ffffff80;
                position: absolute;
                left: -121px;
                bottom: 16px;
                z-index: 25;
              }
            }
            &.item-1 {
              left: 292px;
              &::before {
                content: '';
                height: 1px;
                width: 155px;
                background-color: #ffffff80;
                position: absolute;
                left: -147px;
                bottom: 16px;
                z-index: 25;
              }
            }
            &.item-2 {
              left: 464px;
              &::before {
                content: '';
                height: 1px;
                width: 156px;
                background-color: #ffffff80;
                position: absolute;
                left: -148px;
                bottom: 16px;
                z-index: 25;
              }
            }
            &.item-3 {
              left: 636px;
              &::before {
                content: '';
                height: 1px;
                width: 156px;
                background-color: #ffffff80;
                position: absolute;
                left: -148px;
                bottom: 16px;
                z-index: 25;
              }
              &::after {
                content: '';
                height: 1px;
                width: 426px;
                background-color: #ffffff80;
                position: absolute;
                right: -418px;
                bottom: 16px;
                z-index: 25;
              }
            }
          }
        }
      }
    }
  }
}
</style>
